<template>
   <div id='file_drop_zone' class="drop-zone-wrapper">

      <!-- Initial Form -->
      <!-- <form ref="form" enctype="multipart/form-data" novalidate v-if="isIniitial">
         
         <div id='dropzone_container'>
            <div class="image-container">
               <img class="drag-icon" src="./../../assets/img/drag-graphic.png"> 
            </div>
            <div>Drag Files Here</div>
            <input type="file" 
                  multiple 
                  name="files[]" 
                  :disabled="isSaving" 
                  @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                  :accept="getAccepted" class="input-file">
            <label for="fileupload" class='btn btn-default filestyle'>(Or browse for files to upload)</label>
         </div>

      </form> -->
      <div v-if="isInitial">
         <upload
            :accepted="getAccepted"
            @filesChange="handleFileUpload">
         </upload>
      </div>

      <!-- While assets are uploading -->
      <div v-if="isUploading">
         
         <!-- <div id='dropzone_container'>
            <div class="uploaded-message">Uploading files...</div>
            <div class="files-container">
               <div class="file-row"
                  v-for="file in uploadedFiles"
                  :key="file.recid">
                  <div class="file-row-load-indicator" :style="loadStyle"></div>
                  <div class="file-text-container">
                     <div class="filename">{{file.name}}</div>   
                     <div class="percentage">{{uploadPercentageProgress}}%</div>                  
                  </div>
               </div>
            </div>
         </div> -->
         <uploading
            :uploadedFiles="uploadedFiles"
            :uploadProgress="uploadProgress"
            :uploadTotal="uploadTotal"
            @filesChange="handleFileUpload">
         </uploading>
      </div>

      <!-- After a Successful upload -->
      <!-- <form ref="form" enctype="multipart/form-data" novalidate v-if="isSuccess">
         <div id='dropzone_container'>
            <div class="uploaded-message">Uploaded {{uploadedFiles.length}} file{{uploadedFiles.length > 1 ? 's' : ''}} successfully.</div>
            <div class="files-container">
               <div class="file-row"
                  v-for="file in successFiles"
                  :key="file.recid">
                  <img v-if="currSelectedAssetType != 3" class="file-thumb" :src="GALLERY_HOST + '/' + file.thumbnail">
                  <div class="file-text-container">
                     <div class="filename">{{file.filename}}</div>
                     <div class="file-size">{{file.file_size}}</div>
                  </div>
               </div>
            </div>
            <div>Drag to Upload More Files</div>
            <input type="file" 
                  multiple 
                  name="files[]" 
                  :disabled="isSaving" 
                  @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                  accept="audio/*|video/*|image/*" class="input-file">
            <label for="fileupload" class='btn btn-default filestyle'>(Or browse for files to upload)</label>
         </div>
      </form> -->
      <div v-if="isSuccess">
         <uploaded
            :uploadedFiles="uploadedFiles"
            :successFiles="successFiles"
            @filesChange="handleFileUpload">
         </uploaded>
      </div>

      <div v-if="isFailed">
         The upload failed because the following files have invalid extensions:
         <div class="failed-files">
            <div v-for="f of invalidExtFiles" class="failed-file">{{f.name}}</div>
         </div>
      </div>
   </div>
</template>

<script>
import vueDropzone from "vue2-dropzone";
import Upload from '@/global/upload/Upload';
import Uploading from '@/global/upload/Uploading';
import Uploaded from '@/global/upload/Uploaded';

import { mapState, mapActions, mapGetters } from 'vuex';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
const VALID_IMAGE_TYPES = ['jpg', 'png', 'jpeg'];
const VALID_MOVIE_TYPES = ['mp4', 'mov'];
const VALID_AUDIO_TYPES = ['mp3'];

export default {
   
   data() {
      return {
         // uploadFieldName: '',
         // uploadError: null,
         // uploadedFiles: [],
         // successFiles: [],
         // currentStatus: null,
         // uploadTotal: 0,
         // uploadProgress: 0,
         // uploadedRecids: []
      }
   },

   mounted() {
      this.reset();
   },

   computed: {
      ...mapState('global', [
         'mpChannelRecid',
         'uploadedFiles',
         'successFiles',
         'invalidFiles',
         'invalidExtFiles',
         'uploadProgress',
         'uploadTotal',
         'currSelectedAssetType'
      ]),

      ...mapGetters('global', [
         'isInitial',
         'isUploading',
         'isIngesting',
         'isFetching', 
         'isSuccess', 
         'isFailed',   
      ]),


      // isSaving() {
      //    return this.currentStatus === STATUS_SAVING;
      // },

      // isSuccess() {
      //    return this.currentStatus === STATUS_SUCCESS;
      // },

      // isIniitial() {
      //    return this.currentStatus === STATUS_INITIAL;
      // },

      uploadPercentageProgress() {
         return Math.floor((this.uploadProgress / this.uploadTotal) * 100);
      },

      loadStyle() {
         return "width: " + this.uploadPercentageProgress + "%;";
      },
      
      getAccepted() {
         if (this.currSelectedAssetType == 1) {
            return 'image/*';
         } else if (this.currSelectedAssetType == 2) {
            return 'movie/*';
         } else if (this.currSelectedAssetType == 3) {
            return 'audio/*';
         }
      }
   },

   methods: {
      ...mapActions('global', ['uploadMedia']),

      reset() {
        // reset form to initial state
      //   this.currentStatus = STATUS_INITIAL;
      //   this.uploadedFiles = [];
      //   this.uploadedRecids = [];
      //   this.uploadError = null;
      },

      getStringFromFileType(type) {
         let t = type.split('/')[0];
         if (t == 'image') {
            return 'image';
         } else if (t == 'video') {
            return 'movie';
         } else if (t == 'audio') {
            return 'audio';
         }
      },

      //make sure our file matches the type of asset we're expecting
      isValidFile(file) {
         let ext = file.name.split('.')[1].toLowerCase();
         if (this.currSelectedAssetType == 1) {
            for (let v of VALID_IMAGE_TYPES) {
               if (ext == v) {
                  return true;
               }
            }
            return false;
         } else if (this.currSelectedAssetType == 2) {
            for (let v of VALID_MOVIE_TYPES) {
               if (ext == v) {
                  return true;
               }
            }
            return false;
         } else if (this.currSelectedAssetType == 3) {
            for (let v of VALID_AUDIO_TYPES) {
               if (ext == v) {
                  return true;
               }
            }
            return false;
         }
      },

      handleFileUpload(fieldName, fileList) {
         this.reset();
         let formData = new FormData();
         let self = this;

         if (!fileList.length) return;

         let validFiles = [];
         let invalidFiles = [];
         Array
            .from(Array(fileList.length).keys())
            .map(x => {
               if (self.isValidFile(fileList[x])) {
                  validFiles.push(fileList[x]);
               } else {
                  invalidFiles.push(fileList[x]);
               }
            });

         this.uploadMedia({vm: this, validFiles, invalidFiles});
      },

      // filesChange(fieldName, fileList) {
      //    let formData = new FormData();
      //    let self = this;

      //    if (!fileList.length) return;

      //    // append the files to FormData
      //    Array
      //       .from(Array(fileList.length).keys())
      //       .map(x => {
      //          if (self.isValidFile(fileList[x])) {
      //             formData.append('file[]', fileList[x]);
      //             self.uploadedFiles.push(fileList[x]);
      //          }
      //       });

      //    // formData.append("userFile", fileList[0]);

      //    var xhr = new XMLHttpRequest();
      //    let host = this.API_HOST + '/upload.php';
      //    xhr.open('POST', host, true);

      //    xhr.addEventListener('readystatechange', function(e) {
      //       if( this.readyState === 4 ) {
      //          self.currentStatus = STATUS_SUCCESS;
      //          let i = 0;
      //          self.handleAssetUpload(0, fileList);
      //       }
      //    });

      //    if (xhr.upload) {
      //       // For handling the progress of the upload
      //       xhr.upload.addEventListener('progress', function(e) {
      //          if (e.lengthComputable) {
      //                self.uploadProgress = e.loaded;
      //                self.uploadTotal = e.total;
      //          }
      //       } , false);
      //    }

      //    xhr.send(formData);
      //    this.currentStatus = STATUS_SAVING;
      // },

      // handleAssetUpload(index, fileList) {
      //    let self = this;
         
      //    if (index >= fileList.length) {
      //       //tell parent we've ingested media so we can reload 'Recently Added'
      //       self.$parent.$emit('Ingested');
      //       self.logActivity();
      //       return;
      //    }

      //    //call ingest for one file THEN
      //    self.ingest(fileList[index].name)
      //       .then((recid) => {
      //          //pushing recids for logging
      //          self.uploadedRecids.push(recid);

      //          //call getUploadedAsset for that one file THEN
      //          return self.getUploadedAsset(recid);
      //       }).then(() => {
      //          //increment i
      //          self.handleAssetUpload(++index, fileList);
      //       });
      // },

      // ingest(filename) {
      //    let self = this;
      //    return new Promise((resolve, reject) => {
      //       $.post(
      //          self.BARD_HOST + '/' + self.getAssetString(self.currSelectedAssetType) + '/ingest',
      //          {
      //             token: localStorage.getItem('token'),
      //             uri: filename,
      //             channelRecid: self.mpChannelRecid
      //          }, function(data) {
      //             //return the recid
      //             if (data.error) {
      //                self.handleFailedAPICall('/' + self.getAssetString(self.currSelectedAssetType)+ '/ingest', 'MediaUploadArea', data);
      //                reject(data.message);
      //             } else {
      //                resolve(data.recid);
      //             }
      //          }
      //       ).fail(function(response) {
      //          console.log('Error: ' + response.responseText);
      //       });
      //    });
      // },

      // //this is going to get the meta data for a file we've just uploaded
      // //so that we can display file info in the upload success area
      // getUploadedAsset(recid) {
      //    let self = this;
      //    return new Promise((resolve, reject) => {
      //       $.post(
      //          self.BARD_HOST + '/' + self.getAssetString(self.currSelectedAssetType) + '/meta/' + recid,
      //          {
      //             token: localStorage.getItem('token')
      //          }, function(data) {
      //             if (data.error) {
      //                self.handleFailedAPICall('/' + self.getAssetString(self.currSelectedAssetType) + '/meta/' + recid, 'MediaUploadArea', data);
      //                reject(data.message);
      //             } else {
      //                self.successFiles.push(data);
      //                resolve();
      //             }
      //          }
      //       ).fail(function(response) {
      //          console.log('Error: ' + response.responseText);
      //       });
      //    });
      // },

      logActivity() {
          $.post(
            this.BARD_HOST + '/media/log_upload',
            {
               token: localStorage.getItem('token'),
               fileRecids: this.uploadedRecids.toString()
            }, function(data) {
               if (data.error) {
                  self.handleFailedAPICall('/media/log_upload', 'MediaLibraryUploadCenter', data);
               }
            }
         ).fail(function(response) {
            console.log('Error /media/log_upload: ' + response.responseText);
         });
      }
   },

   components: {
      Upload,
      Uploaded,
      Uploading
   }
}
</script>

<style lang="scss" scoped>
#file_drop_zone {
   border-top: 1px solid white;
   padding: 10px;
}

.drop-zone-wrapper {
   color: white;
}

#dropzone_container {
   background-color: transparent;
   border: none;
   text-align: center;
   position: relative;

   input {
      position: absolute;
      width: 340px;
      height: 237px;
      left: 0;
      top: 0;
      opacity: 0;
   }

   &:hover {
      background-color: rgba(92, 92, 93, 0.5);
   }
}

.drag-icon {
   width: 175px;
   height: 150px;
   position: relative;
   pointer-events: none;
}

.files-container {
   padding-bottom: 10px;
}

.failed-files {
   text-align:center;

   .failed-file {
      font-size: 12px;
      color: $error-red;
   }
}

.uploaded-message {
   padding: 10px 0;
}

.file-row {
   display: flex;
   border: 1px solid $bard-gray;

   &:not(:last-child) {
      border-bottom: none;
   }

   .file-row-load-indicator {
      height: 50px;
      background: rgba(128, 128, 128, .2);
      position: absolute;
      z-index: 0;
   }

   .file-thumb {
      width: 50px;
      height: 50px;
   }

   .file-text-container {
      text-align: left;
      padding-left: 5px;
      padding-top: 6px;
   }

   .filename {
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
   }

   .file-size {
      font-size: 10px;
      color: $bard-gray;
   }
}

.filestyle {
   text-decoration: underline;
   color: $bard-gray;
}
</style>
